import Drawer from '@repo/ui/drawer'
import { PropsWithChildren, useEffect, useState } from 'react'

import useTranslate from '../../../lib/hooks/use-translate'

type Props<TFilters> = {
  isOpen: boolean
  selectedFilter?: TFilters
  isLoading?: boolean
  // Apply button text, "Appliquer" by default
  applyLabel?: string
  onClose: () => void
  onReset: () => void
  onApply: () => void
  onFilterChange: (newFilter?: TFilters) => void
}

type FilterDrawerType = 'none' | 'applied' | 'reset' | 'close'

const FilterDrawer = <TFilters extends object>({
  children,
  isOpen,
  selectedFilter,
  isLoading,
  applyLabel,
  onApply,
  onClose,
  onReset,
  onFilterChange
}: PropsWithChildren<Props<TFilters>>) => {
  const [state, setState] = useState<FilterDrawerType>('none')
  const { t } = useTranslate()

  useEffect(() => {
    // Close the modal after the filter is applied
    if ((state === 'applied' || state === 'reset') && !isLoading) {
      onClose()
      setState('close')
    }
  }, [isLoading])

  return (
    <Drawer
      isOpen={isOpen}
      title={t('filters.title')}
      btnLabel={applyLabel ?? t('filters.apply')}
      resetText={t('filters.reset')}
      onClose={() => {
        onFilterChange(selectedFilter)
        onClose()
        setState('close')
      }}
      onSubmit={() => {
        onApply()
        setState('applied')
      }}
      onReset={() => {
        onReset()
        setState('reset')
      }}
      isResetLoading={state === 'reset' && isLoading}
      isApplyLoading={state === 'applied' && isLoading}
    >
      {children}
    </Drawer>
  )
}

export default FilterDrawer
